import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  profileId: number;
  email: string;
}

export const useCreateProfileContact = () => {
  const { authHeader } = useAuth();

  return useMutation(({ profileId, email }: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/profile/${profileId}/contact/`,
      { email },
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
